import React from 'react';
import { Navigate } from 'react-router-dom';

export default () => <Navigate to="/my-day" replace />;
